<template>
    <div class="flex items-center justify-between rounded-lg border border-ds-primary-200 bg-ds-primary-50 p-4">
        <div class="flex items-center gap-2">
            <DsIcon
                icon="fa-regular fa-file-lines"
                size="md"
            />
            <div>
                <p class="text-content-md text-content-primary">
                    {{ documentConfig.title }}
                </p>
                <p
                    v-if="signersCount"
                    class="text-content-sm text-content-secondary"
                >
                    {{ signersCount }} signer(s)
                </p>
            </div>
        </div>
        <DsIconButton
            icon="fa-regular fa-trash-can"
            size="sm"
            tooltipText="Remove document"
            @click="fileDocumentStore.removeDocument(documentConfig.documentId)"
        />
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsIconButton from '@/components/design-system/DsIconButton.vue';
import { isDocumentTemplateConfig } from '@/components/Views/Company/File/Documents/document-upload-utils';
import type { DocumentUploadConfig } from '@/components/Views/Company/File/file.types';
import { useFileDocumentStore } from '@/stores/file-document.store';
import { computed } from 'vue';

const props = defineProps<{
    documentConfig: DocumentUploadConfig;
}>();

const fileDocumentStore = useFileDocumentStore();

const signersCount = computed(() =>
    isDocumentTemplateConfig(props.documentConfig) ? props.documentConfig.template.signersCount : 0,
);
</script>
